import { Suspense } from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { RouteErrorBoundary } from '@inbody/error';

import { Loading } from '../../components/loading';
import { GenericLayout } from '../../layout';
import { basePageRoute } from './RouterObject';

const browserRouter = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    element: <GenericLayout />,
    children: basePageRoute,
  },
]);

export const BrowserRouter = () => {
  return (
    <Suspense fallback={<Loading minHeight="100vh" />}>
      <RouterProvider router={browserRouter} />
    </Suspense>
  );
};
